import React from 'react';
import ReactDOM from 'react-dom/client';
import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';
import './index.css';
import App from './App';
import { registerGsap } from './animations/registerGsap';

registerGsap();
gsap.registerPlugin(useGSAP);

if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

/* Recover from stale cached JS chunks after deploy */
if (typeof window !== 'undefined') {
  const CHUNK_RELOAD_KEY = 'lumora_chunk_reload';
  window.addEventListener('error', (event) => {
    const msg = String(event.message || '');
    const src = String(event.filename || '');
    const isChunkFailure =
      msg.includes('Loading chunk') ||
      msg.includes('ChunkLoadError') ||
      (src.includes('/static/js/') && msg.includes('Unexpected token'));
    if (!isChunkFailure) return;
    if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) return;
    sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
    window.location.reload();
  });
  window.addEventListener('load', () => {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
